import React from "react"
import styled from "styled-components"
import automateYourEffortsData from "../../data/pageSections/home/automateYourEfforts"
import H2 from "../typography/H2"
import Container from "./Container"
import Section from "./Section"
import H4 from "../typography/H4"

const Arrow = styled.img`
  ${({ theme }) => theme.se`
   transform: rotate(90deg);
    `}
  ${({ theme }) => theme.desktop`
   transform: rotate(0deg);
    `}
`

const CardWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  ${({ theme }) => theme.se`
   flex-direction: column;
    `}

  ${({ theme }) => theme.desktop`
   flex-direction: row;
   justify-content: space-between;
   
    `}
`

const StyledH2 = styled(H2)`
  text-align: center;
`

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${({ theme }) => theme.se`
   width: 100%;
   .gatsby-image-wrapper {
    width: 100%;
    margin-bottom: 1.45rem;
   }
    `}

  ${({ theme }) => theme.desktop`
   width: 20%;
   
    `}
`

const AutomateYourEfforts = () => (
  <>
    <Section
      tint="#f1f5f8"
      clipPath="polygon(100% 0, 100% calc(100% - 6vw), 51% 100%, 0 calc(100% - 6vw), 0 0)"
    >
      <StyledH2>Automate your Marketing for Effortless Results</StyledH2>
    </Section>
    <Section>
      <Container className="padding-top-bottom-20">
        <CardWrapper>
          {automateYourEffortsData.map(
            ({ graphic, title, icon, component }) => (
              <Card>
                {graphic && <img src={graphic} alt={title} title={title} />}
                {component && component}
                {icon && <Arrow src={icon} />}
                {title && <H4>{title}</H4>}
              </Card>
            )
          )}
        </CardWrapper>
      </Container>
    </Section>
  </>
)

export default AutomateYourEfforts
